// Versione "lite" di MobileEvent (riga evento prematch) per la home di gojjobet.
// Logica da awrabet, template tournament lite.
import {h, Fragment} from "preact";
import {route} from "preact-router";

import Ticket from "../../jamibet/utils/ticket-logic.jsx";
import * as I from "../../jamibet/utils/icons.jsx";
import * as P from "./templates-tournament.jsx";

import { MobileEvent as AwrabetMobileEvent } from "../../awrabet/mobile-pages/prematch-tournament.jsx";

export class MobileEvent extends AwrabetMobileEvent {
	render({tournament, event, displayRuleFiltered}) {
		return <P.MatchRow>
			<P.MatchInfo onClick={() => route("/prematch/"+tournament.id.split('/').slice(2).join('/')+'/'+event.id.split('/').slice(2).join('/'))}>
				<P.Teams>
					<P.HomeTeamName>{event.home}</P.HomeTeamName>
					<P.AwayTeamName>{event.away}</P.AwayTeamName>
				</P.Teams>
				<P.MatchTime>{this.getLocalEventTime(event)}</P.MatchTime>
			</P.MatchInfo>
			<P.StatsCell><I.StatsIcon class="w-4" /></P.StatsCell>
			{displayRuleFiltered.map(outcome => {
				const [marketCode, outcomeCode] = outcome.id.split('.');
				const market = event.sub['/market/'+event.id.split('/').slice(-1)[0]+'/'+marketCode] || {sub:{}}
				const odd = market.sub[market.id.replace('market', 'odd')+'/'+outcomeCode] || {value: 0, active: false};
				return <P.OddButtonCell>
					<P.OddButton
						value={odd.value}
						active={odd.active}
						onClick={() => Ticket.togglePrematchOdds(odd.id)}
						selected={Ticket.hasPrematchOdds(odd.id)} />
				</P.OddButtonCell>;
			})}
			<P.StarCell><I.FavouritesIcon class="h-6" /></P.StarCell>
		</P.MatchRow>;
	}
}
